// import CvTemplate1 from "../../component/CvTemplate1";
// import CvTemplate2 from "../../component/CvTemplate2";
// import CvTemplate3 from "../../component/CvTemplate3";
// import { usePDF } from "react-to-pdf";
// import { JOBSEEKER_URL } from "../../resources/resource";
// import { useFetchData } from "../../hooks/useFtechData";

// import { Link } from "react-router-dom";
// import FooterComponent from "../../component/Footer";
// import Header from "../../component/Header";
// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";

// function TemplateCV() {
//   const [shareOption, setShare] = useState(false);
//   const [templateNumber, setTemplateNumber] = useState(1);
//   const loggedInUser = useSelector((state) => state.user);
//   const { toPDF, templateRef: pdfTargetRef } = usePDF({
//     filename: `Template ${templateNumber}`,
//   });

//   const { data: userDetails, refetch: refetchUser } = useFetchData(
//     JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
//   );

//   const renderTemplate = (templateNum) => {
//     const commonProps = {
//       download: toPDF,
//       education: userDetails?.education || [],
//       experience: userDetails?.workExperience || [],
//       certificate: userDetails?.certificates || [],
//       guarantor: userDetails?.guarantors || [],
//     };

//     switch (templateNum) {
//       case 1:
//         return <CvTemplate1 {...commonProps} />;
//       case 2:
//         return <CvTemplate2 {...commonProps} />;
//       case 3:
//         return <CvTemplate3 {...commonProps} />;
//       default:
//         return <CvTemplate1 {...commonProps} />;
//     }
//   };

//   // Set initial template after data is loaded
//   useEffect(() => {
//     if (userDetails) {
//       setTemplate(renderTemplate(templateNumber));
//     }
//   }, [userDetails, templateNumber]);

//   const [template, setTemplate] = useState(() => renderTemplate(1));

//   const handleTemplate = (num) => {
//     setTemplateNumber(num);
//     setTemplate(renderTemplate(num));
//   };

//   const handleShare = () => {
//     setShare(!shareOption);
//   };

//   const handleBody = () => {
//     shareOption === true && setShare(false);
//   };

//   // Show loading state while data is being fetched
//   if (!userDetails) {
//     return (
//       <div className="text-sm pt-16 sm:pt-20 flex items-center justify-center min-h-screen">
//         <p>Loading your CV data...</p>
//       </div>
//     );
//   }

//   return (
//     <div onClick={handleBody} className="text-sm pt-16 sm:pt-20">
//       <div className="sm:px-24 px-4">
//         <Header />
//         <div className="mt-6 flex items-center justify-between">
//           <div>
//             <h3 className="font-semibold inline-block mr-8">Download CV</h3>
//             <p className="inline-block">
//               You can choose from the 3 template which best goes with your taste
//               and download it
//             </p>
//           </div>
//         </div>
//         <div className="flex items-start justify-start gap-12 mt-16">
//           <div className="w-1/6 h-auto">
//             {[1, 2, 3].map((num) => (
//               <button
//                 key={num}
//                 onClick={() => handleTemplate(num)}
//                 className={`hover:bg-orange-500 block py-1 px-4 text-slate-50 rounded-md mb-4 ${
//                   templateNumber === num ? "bg-orange-500" : "bg-slate-800"
//                 }`}
//               >
//                 Template {num}
//               </button>
//             ))}
//             <Link
//               className="bg-red-500 px-4 py-2 text-white rounded-sm"
//               to={`/profile/${loggedInUser.currentUser._id}`}
//             >
//               Profile
//             </Link>
//           </div>
//           {/* template region */}
//           <div className="w-5/6" ref={pdfTargetRef}>
//             {template}
//           </div>
//         </div>
//       </div>
//       <FooterComponent />
//     </div>
//   );
// }

// export default TemplateCV;






import CvTemplate1 from "../../component/CvTemplate1";
import CvTemplate2 from "../../component/CvTemplate2";
import CvTemplate3 from "../../component/CvTemplate3";
import { usePDF } from "react-to-pdf";
import { JOBSEEKER_URL } from "../../resources/resource";
import { useFetchData } from "../../hooks/useFtechData";

import { Link } from "react-router-dom";
import FooterComponent from "../../component/Footer";
import Header from "../../component/Header";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function TemplateCV() {
  const [shareOption, setShare] = useState(false);
  const [templateNumber, setTemplateNumber] = useState(1);
  const loggedInUser = useSelector((state) => state.user);

  const { toPDF, templateRef: pdfTargetRef } = usePDF({
    filename: `Template ${templateNumber}`,
  });

  const { data: userDetails, refetch: refetchUser } = useFetchData(
    JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
  );

  const renderTemplate = (templateNum) => {
    const commonProps = {
      download: toPDF,
      education: userDetails?.education || [],
      experience: userDetails?.workExperience || [],
      certificate: userDetails?.certificates || [],
      guarantor: userDetails?.guarantors || [],
    };

    switch (templateNum) {
      case 1:
        return <CvTemplate1 {...commonProps} />;
      case 2:
        return <CvTemplate2 {...commonProps} />;
      case 3:
        return <CvTemplate3 {...commonProps} />;
      default:
        return <CvTemplate1 {...commonProps} />;
    }
  };

  // Set initial template after data is loaded
  useEffect(() => {
    if (userDetails) {
      setTemplate(renderTemplate(templateNumber));
    }
  }, [userDetails, templateNumber]);

  const [template, setTemplate] = useState(() => renderTemplate(1));

  const handleTemplate = (num) => {
    setTemplateNumber(num);
    setTemplate(renderTemplate(num));
  };

  const handleShare = () => {
    setShare(!shareOption);
  };

  const handleBody = () => {
    shareOption === true && setShare(false);
  };

  // Show loading state while data is being fetched
  if (!userDetails) {
    return (
      <div className="text-sm pt-16 sm:pt-20 flex items-center justify-center min-h-screen">
        <p>Loading your CV data...</p>
      </div>
    );
  }

  return (
    <div onClick={handleBody} className="text-sm pt-16 sm:pt-20">
      <div className="px-4 sm:px-6 lg:px-24">
        <Header />

        {/* Header Section */}
        <div className="mt-6 mb-8">
          <h3 className="font-semibold text-xl sm:text-2xl mb-2">Download CV</h3>
          <p className="text-gray-600 text-sm sm:text-base">
            Choose from the 3 templates which best suits your taste and download it
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          {/* Template Selector Sidebar */}
          <div className="w-full lg:w-1/6 flex-shrink-0">
            <div className="sticky top-24 space-y-3">
              <div className="text-sm font-medium text-gray-500 mb-2 hidden lg:block">
                Choose Template
              </div>

              {[1, 2, 3].map((num) => (
                <button
                  key={num}
                  onClick={() => handleTemplate(num)}
                  className={`w-full text-left py-3 px-5 rounded-xl text-sm font-medium transition-all duration-200
                    ${
                      templateNumber === num
                        ? "bg-orange-500 text-white shadow-md"
                        : "bg-slate-800 hover:bg-slate-700 text-slate-50"
                    }`}
                >
                  Template {num}
                </button>
              ))}

              <Link
                to={`/profile/${loggedInUser.currentUser._id}`}
                className="block w-full text-center bg-red-500 hover:bg-red-600 transition-colors text-white font-medium py-3 px-5 rounded-xl mt-6"
              >
                Go to Profile
              </Link>
            </div>
          </div>

          {/* CV Preview Area */}
          <div className="w-full lg:w-5/6">
            <div 
              ref={pdfTargetRef}
              className="bg-white shadow-lg rounded-2xl overflow-hidden mx-auto 
                         max-w-[210mm] min-h-[297mm] border border-gray-200"
            >
              {template}
            </div>

            {/* Optional: Download hint for mobile */}
            <p className="text-center text-xs text-gray-500 mt-4 lg:hidden">
              Preview shown above • Use desktop for best PDF export quality
            </p>
          </div>
        </div>
      </div>

      <FooterComponent />
    </div>
  );
}

export default TemplateCV;